export default ({ route, from, redirect, store }) => {
  if (route.fullPath === from.fullPath && route.fullPath === '/') {
    const isLoggedIn = (store.getters['auth/currentUser'] || {}).id;
    if (!isLoggedIn) return;
    const lastVisitedPage = window.localStorage.getItem('lastVisitedPage') || '/space';
    redirect(lastVisitedPage);
  }
};
